var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.35.5A12.51 12.51 0 004 12.85c0 9.26 10.43 17.65 11.62 18.53.207.165.465.253.73.25.246 0 .486-.073.69-.21 1.19-.82 11.65-8.28 11.65-18.57A12.51 12.51 0 0016.35.5zm0 28.93C14.15 27.61 6 20.5 6 12.85A10.49 10.49 0 0116.35 2.5a10.48 10.48 0 0110.34 10.35c0 8.46-8.06 14.94-10.31 16.58h-.03z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.35 15.64a3 3 0 100-6 3 3 0 000 6z"
  })));
}

export default SvgArea;